import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const ProductVariantCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Variant",
    cell: (row) => {
      return (
        Array.from(
          new Set(row.items?.map((item) => item.variantTitle).filter(Boolean)),
        )?.join(", ") ?? ""
      );
    },
    expandedCsvCell: (row, expansionIndex) => {
      return getExpandedItems(row)?.[expansionIndex]?.variantTitle ?? "";
    },
  };
